import React from 'react';
import { XPagination } from '@/components/xqxc_ui';
import { Table, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, cellWidth, tooltipClick, switchCell, ImgCell } from '@/components/TableCell';
import styles from './TableList.module.scss';
import { MainTableFields as tf, TableAction as ta } from '../../types';

class TableList extends React.Component {

    _takeColumns = () => ([
        {
            title: '广告位名称',
            dataIndex: tf.adSpaceName,
            key: tf.adSpaceName,
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => tooltipClick(text, () => {
                this.props.tableAction(record.id, ta.adPosition, record);
            })
        },
        {
            title: '使用位置',
            dataIndex: tf.adPosition,
            key: tf.adPosition,
            width: '10%',
            align: 'center',
            render: (text, record) => {
                return (
                    <div className={styles.usePosition}>
                        {ImgCell(record.previewUrl)}
                        <Tooltip title={text}>
                            <div className={styles.text}>{text}</div>
                        </Tooltip>
                    </div>
                );
            }
        },
        {
            title: '投放中广告数量',
            dataIndex: tf.putAdTotal,
            key: tf.putAdTotal,
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: tf.state,
            key: tf.state,
            width: '10%',
            align: 'center',
            onCell: tooltipStyle,
            render: (text, record) => switchCell(text, () => this.props.tableAction(text, ta.state, record))
        },
        {
            title: '操作',
            dataIndex: 'action',
            key: 'action',
            width: '10%',
            align: 'center',
            render: (text, item) => this._renderActionCell(item.id, item)
        }
    ]);

    _renderActionCell = (key, item) => {
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => this.props.tableAction(key, ta.manage, item)}>管理</div>
            </div>
        );
    }

    render() {
        const { paginationChange } = this.props;
        const { pageNum, pageSize, resultTotal, dataList } = this.props.renderData;
        return (
            <div className={styles.tableContainer}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={(record, index) => index}
                    columns={this._takeColumns()}
                    dataSource={dataList}
                    pagination={false}
                    scroll={{ y: true }}
                />
                <XPagination
                    resultTotal={resultTotal}
                    pageSize={pageSize}
                    pageNum={pageNum}
                    onChange={paginationChange}
                />
            </div>
        );
    }
}

TableList.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
    actionHandle: PropTypes.func,
};

export default TableList;